export default __webpack_public_path__ + "static/media/MARKETING.368e2076.jpg";